(() => {
	'use strict';
	$('#autor-wrapper').on('click', '.pagination a', function (evt) {
		evt.preventDefault();
		window.ajaxNavigateTo(this.href, 'autor-artikel');
		return false;
	});
})();
